export default "__VITE_ASSET__Dt$eym6L__"